module.exports = __webpack_public_path__ + "static/media/plank.a6a32336.png";